import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';

@Component({
  selector: 'app-top-bottom-button',
  templateUrl: './top-bottom-button.component.html',
  styleUrls: ['./top-bottom-button.component.css']
})
export class TopBottomButtonComponent {
  @ViewChild('down') down!: ElementRef<HTMLButtonElement>

  showTopButton = false;
  showBottomButton = true;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

    this.showTopButton = scrollPosition > 200;

    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    this.showBottomButton = scrollPosition < documentHeight - windowHeight - 200;
  }

  toTop() {
    window.scrollTo(0, 0)
  }

  toBottom() {
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const scrollToPosition = documentHeight - windowHeight;

    window.scrollTo(0, scrollToPosition);
  }
}
